module.exports = __webpack_public_path__ + "img/Drone Shipping.2611f114.svg";